import ViewCad from "../../../config/view";
import { SalaViewProps } from "../sala.controller";
import { Sala } from "../sala.model";

interface SalaCadastroProps extends SalaViewProps {
    handleCloseView: () => any
}

export function SalaCadastro(props: SalaCadastroProps) {
    const { salaActions,salaState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = salaState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = salaActions

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: Sala) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Sala) => {
        const errors: any = {}
        if (!values.descricao)
            errors.descricao = "Informe descrição da sala"
        return errors
    }

    const handleUpdate = (value: Sala) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro da sala",
        formFieldDescription: "descricao",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar nova sala",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        contentForm: [
            { fieldName: "descricao", label: "Sala", type: "text", key: "descricao", colunsXS: 12, colunsSM: 12, colunsMD: 12, require: true },
        ],
    })

    return viewCad
}



